export default {
  qmulusMaterialSelected: 'Wybrano materiał Qmulus. Zapisane zostaną wartości analizy, ale nie nazwa materiału.',
  pt9800MaterialSelected: 'Wybrano materiał PT9800. Jego analizy nie można zmienić.',
};
